import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import PostInspectionDiyModal from "./component";

const mapStateToProps = ({
    postInspectionDiy: {
        isMobile
    }
}) => ({
    isMobile
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(PostInspectionDiyModal);
